import type { Site } from '../Site';

export const PracticalCaravan: Site = {
  id: 'practicalcaravan',
  logo: 'svg/practicalcaravan.svg',
  label: 'PracticalCaravan',
  analyticsName: 'practicalcaravan',
  hostname: 'practicalcaravan.com',
  platform: 'practical',
  selector: 'article a',
};
